import { AttendeeAdvancedFilterTypes as ApiEnum } from "generated/api";

const AttendeeDateFilterDisplay = new Map<ApiEnum, string>([
  [ApiEnum.SupplierContractDate, "Supplier Contract Date"],
  [ApiEnum.SpeakerBfr, "Delegate/Speaker BFR"],
  [ApiEnum.CancellationDate, "Cancellation Date"],
]);

export { AttendeeDateFilterDisplay };
